import { useNavigate } from 'react-router-dom';
import LandingPage from '../LandingPage';
import LoginPage from '../LoginPage';
import ForgotPasswordPage from '../ForgotPasswordPage';
import ResetPasswordPage from '../ResetPasswordPage';
import PrivacyPolicyPage from '../PrivacyPolicyPage';
import TermsConditionsPage from '../TermsConditionsPage';
import AcceptableUsePage from '../AcceptableUsePage';
import PrivateBetaPage from '../PrivateBetaPage';

/**
 * Public Routes - No authentication required
 */

export function LandingPageRoute() {
    const navigate = useNavigate();
    return (
        <LandingPage
            onEnterApp={() => navigate('/invite')}
            onLogin={() => navigate('/login')}
            onSignup={() => navigate('/invite')}
        />
    );
}

export function LoginPageRoute() {
    const navigate = useNavigate();
    return (
        <LoginPage
            onBack={() => navigate('/')}
            onSwitchToSignup={() => navigate('/invite')}
            onSuccess={() => navigate('/dashboard')}
            onForgotPassword={() => navigate('/forgot-password')}
        />
    );
}

export function ForgotPasswordPageRoute() {
    const navigate = useNavigate();
    return (
        <ForgotPasswordPage
            onBack={() => navigate('/')}
            onBackToLogin={() => navigate('/login')}
        />
    );
}

export function ResetPasswordPageRoute() {
    const navigate = useNavigate();
    return (
        <ResetPasswordPage
            onBack={() => navigate('/')}
            onBackToLogin={() => navigate('/login')}
        />
    );
}

export function PrivacyPolicyPageRoute() {
    const navigate = useNavigate();
    return (
        <PrivacyPolicyPage
            onBack={() => navigate('/')}
        />
    );
}

export function TermsConditionsPageRoute() {
    const navigate = useNavigate();
    return (
        <TermsConditionsPage
            onBack={() => navigate('/')}
        />
    );
}

export function AcceptableUsePageRoute() {
    const navigate = useNavigate();
    return (
        <AcceptableUsePage
            onBack={() => navigate('/')}
        />
    );
}

export function PrivateBetaPageRoute() {
    const navigate = useNavigate();
    return (
        <PrivateBetaPage
            onBack={() => navigate('/')}
            onHaveCode={() => navigate('/invite')}
        />
    );
}
